export default {
	purchase: 'شراء',
	sell: 'بيع'
}